import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';
import { Observable, map } from 'rxjs';

import { ShiftListSearchCriteria } from '../models/shift-list.model';

@Injectable({
  providedIn: 'root'
})
export class ShiftService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.shift;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public list(criteria: ShiftListSearchCriteria): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.list, {
      storeNo
    });
    const params = this.getParams(criteria, true);

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  public view(request): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;
    let refId = request.refId;
    const url = this.getFullUrl(this.envService.view, {
      storeNo,
      refId
    });

    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(),
      observe: 'body',
      responseType: 'json'
    });
  }

  public detail(docNo): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.detail, {
      storeNo,
      docNo
    });

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body'
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  public validateActiveDevice(documentNo): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.validateActiveDevice, {
      storeNo,
      documentNo
    });

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(),
        observe: 'body'
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  public validate(request): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.validate, {
      storeNo,
      documentNo: request.documentNo
    });

    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(500),
      observe: 'body'
    });
  }

  public submit(request): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.submit, {
      storeNo,
      documentNo: request.documentNo
    });

    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(500),
      observe: 'body'
    });
  }

  public print(documentNo: any): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.print, {
      storeNo,
      documentNo
    });

    let headers = this.loaderHeaders(300);
    headers = headers.set('Content-Type', 'application/pdf');

    return this.http
      .get<any>(url, {
        headers: headers,
        observe: 'body'
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
}
